const config = {
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' 
      ? 'http://bunnystepsapi.smartrabbitz.com'
      : 'http://localhost:5001'),
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  },

  // Authentication Configuration
  auth: {
    supabaseUrl: process.env.REACT_APP_SUPABASE_URL,
    supabaseAnonKey: process.env.REACT_APP_SUPABASE_ANON_KEY,
    tokenKey: 'bunnysteps_token',
    refreshTokenKey: 'bunnysteps_refresh_token',
  },

  // Feature Flags
  features: {
    enableNotifications: process.env.REACT_APP_ENABLE_NOTIFICATIONS === 'true',
    enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
    enableErrorReporting: process.env.REACT_APP_ENABLE_ERROR_REPORTING === 'true',
  },

  // App Configuration
  app: {
    name: 'Bunny Steps',
    version: process.env.REACT_APP_VERSION || '0.1.0',
    environment: process.env.NODE_ENV || 'development',
    debug: process.env.NODE_ENV !== 'production',
  },

  // Bot Configuration
  bot: {
    name: process.env.REACT_APP_BOT_NAME || 'Peter',
  },

  // Logging Configuration
  logging: {
    level: process.env.REACT_APP_LOG_LEVEL || (process.env.NODE_ENV === 'production' ? 'error' : 'debug'),
    enableConsole: true, //process.env.NODE_ENV !== 'production',
  },

  // Project Details V2 (paginated tasks)
  projectDetailsV2: {
    tasksPerPage: parseInt(process.env.REACT_APP_PROJECT_DETAILS_TASKS_PER_PAGE, 10) || 5
  },

  // Performance Configuration
  performance: {
    enableServiceWorker: process.env.REACT_APP_ENABLE_SERVICE_WORKER === 'true',
    enableCaching: process.env.REACT_APP_ENABLE_CACHING === 'true',
    cacheVersion: process.env.REACT_APP_CACHE_VERSION || '1.0.0',
  }
};

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_SUPABASE_URL',
  'REACT_APP_SUPABASE_ANON_KEY'
];

const missingEnvVars = requiredEnvVars.filter(envVar => !process.env[envVar]);

if (missingEnvVars.length > 0) {
  console.error('Missing required environment variables:', missingEnvVars);
  if (process.env.NODE_ENV === 'production') {
    throw new Error('Missing required environment variables');
  }
}

export default config; 